module.exports = __webpack_public_path__ + "img/icon-return.e499f27f.svg";